<template>

    <div class="empty-spoum-area">

        <p class="text-lSemibold">{{$t('no_spams_identified_title')}}</p>

        <p class="text-baseRegular color__moon mt__8">{{$t('no_spams_identified_desc')}}</p>

    </div>

</template>

<script>
export default {

    name: 'empty-spoum-area'

}
</script>

<style lang="scss" scoped>

.empty-spoum-area {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  padding: 16px;
  background-color: $timberwolf;
}

</style>
